import { pxToRem } from "@getbread/dough";
import { styled } from "@mui/material/styles";
import { NavLink } from "react-router";

const sharedNavStyles = `
	font-size: ${pxToRem(16)};
	font-weight: 500;
	margin-right: var(--space-s);
	padding: var(--space-s);
	text-decoration: none;
`;

const HeaderExteriorLink = styled("a")`
	${sharedNavStyles};
	color: ${({ theme }) => theme.palette.text.primary};
`;

const HeaderLink = styled(NavLink)`
	${sharedNavStyles};
	color: ${({ theme }) => theme.palette.text.primary};

	&.active {
		color: ${({ theme }) => theme.palette.primary.main};
	}
`;

export { HeaderLink, HeaderExteriorLink };
